import { render, staticRenderFns } from "./AppContent.vue?vue&type=template&id=5956f05e&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./AppContent.vue?vue&type=script&lang=js&"
export * from "./AppContent.vue?vue&type=script&lang=js&"
import style0 from "./AppContent.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5956f05e')) {
      api.createRecord('5956f05e', component.options)
    } else {
      api.reload('5956f05e', component.options)
    }
    module.hot.accept("./AppContent.vue?vue&type=template&id=5956f05e&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&", function () {
      api.rerender('5956f05e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/AppContent.vue"
export default component.exports